import axios from 'axios';
import store from 'store';
const url = process.env.VUE_APP_HOST;
const urlAdmin = process.env.VUE_APP_HOST_ADMIN;
export default class UpdateService {
	makeHeader(token) {
		return {
			Authorization: token,
			'Content-tType': 'application/json'
		};
	}
	signToken(token) {
		return axios.get(urlAdmin, {
			headers: {
				Authorization: `Bearer ${token}`,
				'Content-tType': 'application/json'
			}
		});
	}
	addUser(user, token) {
		return axios.post(url, user, { headers: this.makeHeader(token) });
	}
	addFfb(id, oldFfb, token) {
		return axios.patch(
			`${url}?id=eq.${id}`,
			{ ffb: oldFfb + 1 },
			{ headers: this.makeHeader(token) }
		);
	}
	takeFfb(id, oldFfb, token) {
		return axios.patch(
			`${url}?id=eq.${id}`,
			{ ffb: oldFfb - 1 },
			{ headers: this.makeHeader(token) }
		);
	}
	addBlame(id, oldBlame, token) {
		return axios.patch(
			`${url}?id=eq.${id}`,
			{ blame: oldBlame + 1 },
			{ headers: this.makeHeader(token) }
		);
	}
	takeBlame(id, oldBlame, token) {
		return axios.patch(
			`${url}?id=eq.${id}`,
			{ blame: oldBlame - 1 },
			{ headers: this.makeHeader(token) }
		);
	}
	getUsers() {
		return axios.get(url).then(res => {
			return res.data;
		});
	}
}
